<template>
  <div class="container-fluid p-0 m-0">
    <div class="row text-left bg-light border-bottom py-3 px-3 d-flex justify-content-between">
      <div class="col-auto">
        <h5 class="mb-0 font-weight-bold">Onboard Listing With Earmarked Relievers</h5>
      </div>
      <div class="col-auto">
        <button class="btn btn-xs btn-outline-secondary px-2 mr-1" title="Go to Previous Page"
                @click="goBack"
        >
          <span class="fas fa-backward"></span>
          Go Back
        </button>
      </div>
    </div>

    <div class="row py-2 px-3">
      <div class="col-10 text-left">
        <div class="form-inline d-flex justify-content-start w-100">
          <div class="form-group py-1 mr-3" v-show="user.manning_id === null">
            <label for="manningSelection" class="form-label-xs font-weight-bold">
              Manning:
            </label>
            <select id="manningSelection" v-model="params.manning_id" class="form-control form-control-xs mx-2">
              <option id="manningNullOption" :value="null">--- Select Manning ---</option>
              <option v-for="manning in getManningLists" :key="manning.id" :value="manning.id">{{ manning.alias }}</option>
            </select>
          </div>
          <div class="form-group py-1 mr-3">
            <label for="manningSelection" class="form-label-xs font-weight-bold">
              Vessel:
            </label>
            <select id="vesselSelection" v-model="params.vessel_id" :disabled="params.manning_id === null" class="form-control form-control-xs mx-2">
              <option id="vesselNullOption" :value="null">--- Select Vessel ---</option>
              <option v-for="vessel in vesselKeys" :key="vessel.id" :value="vessel.id">{{ vessel.name }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-2 text-left d-flex justify-content-end" v-if="!isKline">
        <button :disabled="onboardWithEarmarkedRelievers.length === 0" class="btn btn-primary btn-sm" v-if="!isEditable" @click="toggleEditButton">
          Edit List
        </button>
        <button class="btn btn-danger btn-sm" v-else @click="toggleEditButton">
          Cancel
        </button>
      </div>
      <div style="height: 40px" class="col-12 mt-1 d-flex justify-content-end" v-if="isEditable">
        <button class="btn btn-outline-success btn-sm mx-2" @click="saveList">
          Save List
        </button>
        <button @click="setOnboardListIndex(-1)" class="btn btn-outline-primary btn-sm" data-target="#searchCrew" data-toggle="modal">
          Add Additional Crew Reliever
        </button>
      </div>
    </div>
    <div class="col col-12">
      <table class="table table-sm table-hover table-bordered table-template-1 text-small table-striped my-2 sticky-header">
        <thead>
        <tr>
          <th colspan="6" class="divider">DISEMBARKING CREW</th>
          <th colspan="5">CREW RELIEVER</th>
        </tr>
          <tr>
            <th @click="sortColumn('disembarking_crew_rank')">
              <div class="d-flex justify-content-center">
                Rank

                <template v-if="sortBy.key === 'disembarking_crew_rank'">
                  <div class="d-flex">
                    <b-icon-arrow-up :variant="sortBy.direction === 'asc' ? 'success' : ''" font-scale="1.5"></b-icon-arrow-up>
                    <b-icon-arrow-down :variant="sortBy.direction === 'desc' ? 'success' : ''" font-scale="1.5"></b-icon-arrow-down>
                  </div>
                </template>
              </div>
            </th>
            <th @click="sortColumn('disembarking_crew_name')">
              <div class="d-flex justify-content-center">
                Name

                <template v-if="sortBy.key === 'disembarking_crew_name'">
                  <div class="d-flex">
                    <b-icon-arrow-up :variant="sortBy.direction === 'asc' ? 'success' : ''" font-scale="1.5"></b-icon-arrow-up>
                    <b-icon-arrow-down :variant="sortBy.direction === 'desc' ? 'success' : ''" font-scale="1.5"></b-icon-arrow-down>
                  </div>
                </template>
              </div>
            </th>
            <th @click="sortColumn('disembarking_crew_embark_date')" nowrap>
              <div class="d-flex justify-content-center">
                Embark Date

                <template v-if="sortBy.key === 'disembarking_crew_embark_date'">
                  <div class="d-flex">
                    <b-icon-arrow-up :variant="sortBy.direction === 'asc' ? 'success' : ''" font-scale="1.5"></b-icon-arrow-up>
                    <b-icon-arrow-down :variant="sortBy.direction === 'desc' ? 'success' : ''" font-scale="1.5"></b-icon-arrow-down>
                  </div>
                </template>
              </div>
            </th>
            <th @click="sortColumn('disembarking_crew_contract')" nowrap>
              <div class="d-flex justify-content-center">
                Contract (mos)
                <template v-if="sortBy.key === 'disembarking_crew_contract'">
                  <div class="d-flex">
                    <b-icon-arrow-up :variant="sortBy.direction === 'asc' ? 'success' : ''" font-scale="1.5"></b-icon-arrow-up>
                    <b-icon-arrow-down :variant="sortBy.direction === 'desc' ? 'success' : ''" font-scale="1.5"></b-icon-arrow-down>
                  </div>
                </template>
              </div>
            </th>
            <th @click="sortColumn('disembarking_time_onboard')" nowrap>
              <div class="d-flex justify-content-center">
                Time Onboard

                <template v-if="sortBy.key === 'disembarking_time_onboard'">
                  <div class="d-flex">
                    <b-icon-arrow-up :variant="sortBy.direction === 'asc' ? 'success' : ''" font-scale="1.5"></b-icon-arrow-up>
                    <b-icon-arrow-down :variant="sortBy.direction === 'desc' ? 'success' : ''" font-scale="1.5"></b-icon-arrow-down>
                  </div>
                </template>
              </div>
            </th>
            <th class="divider">

                <div style="width: 100%">
                  PLAN
                </div>
              <div class="d-flex justify-content-around">
                <div>
                  Date of Change
                </div>
                <div>
                  Port of Change
                </div>
              </div>
            </th>
            <th>Rank</th>
            <th>Name</th>
            <th>

                <div>
                  EXPERIENCE ON PRESENT RANK
                </div>
              <div class="d-flex justify-content-around">
                <div>
                  YRS
                </div>
                <div>
                  MOS
                </div>
              </div>
            </th>
            <th>
              <div class="col-12">
                PROMOTION
                <br />
                (Experience on last rank)
              </div>
              <div class="d-flex justify-content-around">
                <div>
                  YRS
                </div>
                <div>
                  MOS
                </div>
              </div>
            </th>
            <th>LAST VESSEL</th>
          </tr>
        </thead>
        <tbody>
        <tr v-if="isLoading">
          <td colspan="100%">
            <app-loading></app-loading>
          </td>
        </tr>

        <tr v-else-if="onboardWithEarmarkedRelievers.length === 0">
          <td colspan="99" style="font-size: 1.5em" class="text-center font-weight-bold">
            NO RESULT
          </td>
        </tr>

        <tr v-else v-for="(onboardListEntry, index) in sortedOnboardList" :class="onboardListEntry.hide_record !== undefined ? 'hide_record' : ''" :key="index">
          <template v-if="onboardListEntry.disembarking_crew_activity === ''">
            <td class="empty_cell"></td>
            <td class="empty_cell"></td>
            <td class="empty_cell"></td>
            <td class="empty_cell"></td>
            <td class="empty_cell"></td>
          </template>
          <template v-else>
            <td :class="onboardListEntry.disembarking_crew_activity.end_status_id !== 1 ? '' : 'inactive-record'">{{ onboardListEntry.disembarking_crew_activity.rank.alias2.toUpperCase() }}</td>
            <td :class="onboardListEntry.disembarking_crew_activity.end_status_id !== 1 ? '' : 'inactive-record'" nowrap>{{ fullName(onboardListEntry.disembarking_crew_activity.crew) }}</td>
            <td class="text-center" :class="onboardListEntry.disembarking_crew_activity.end_status_id !== 1 ? '' : 'inactive-record'">{{ getCrewEmbarkationDate(onboardListEntry) }}</td>
            <td class="text-center" :class="onboardListEntry.disembarking_crew_activity.end_status_id !== 1 ? '' : 'inactive-record'">{{ onboardListEntry.disembarking_crew_contract_duration }}</td>
            <td class="text-center" :class="onboardListEntry.disembarking_crew_activity.end_status_id !== 1 ? '' : 'inactive-record'">{{ onboardListEntry.disembarking_crew_time_onboard }}</td>
          </template>
            <td class="divider" :class="onboardListEntry.active === 1 || onboardListEntry.active === null ? '' : 'inactive-record'">
              <div class="row">
                <div class="col-6">
                  <input
                      type="date"
                      :min="getDateToday()"
                      v-model="onboardListEntry.date_of_change"
                      class="form-control form-control-xs"
                      :class="{
                        required_field : (onboardListEntry.crew_reliever !== '' && onboardListEntry.date_of_change === '') ||
                        new Date(onboardListEntry.date_of_change).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0) ||
                        new Date(onboardListEntry.date_of_change).getFullYear() > 5000
                      }"
                      :disabled="!isEditable || onboardListEntry.crew_reliever === '' || !onboardListEntry.active"
                  >
                </div>
                <div class="col-6">
                  <select
                      class="form-control form-control-xs w-100"
                      v-model="onboardListEntry.port_of_change"
                      :class="{
                        required_field : (onboardListEntry.crew_reliever !== '' && onboardListEntry.port_of_change === '')
                      }"
                      :disabled="!isEditable || onboardListEntry.crew_reliever === '' || !onboardListEntry.active"
                  >
                    <option value="">Select Port of Change</option>
                    <option v-for="port in portKeys" :key="port.id" :value="port.id">{{ port.name }}</option>
                  </select>
                </div>
              </div>
            </td>
          <template v-if="onboardListEntry.crew_reliever === ''">
            <td></td>
            <td nowrap>
              <button @click="setOnboardListIndex(index)" class="w-100 btn btn-sm" :class="isEditable ? 'btn-primary' : 'btn-secondary'" :disabled="!isEditable" data-target="#searchCrew" data-toggle="modal">
                -- Add Crew --
              </button>
            </td>
          </template>
          <template v-else>
            <td :class="onboardListEntry.active === 1 || onboardListEntry.active === null ? '' : 'inactive-record'">{{ onboardListEntry.crew_reliever_rank.alias2.toUpperCase() }}</td>
            <td :class="onboardListEntry.active === 1 || onboardListEntry.active === null ? '' : 'inactive-record'" nowrap>
              <div class="d-flex justify-content-between">
                <div class="mr-2">
                  <a
                      :style="onboardListEntry.active === 1 || onboardListEntry.active === null ? '' : {color: 'white'}"
                      :href="'/cms/crews/index/' + onboardListEntry.crew_reliever.id + '/activities'"
                      target="_blank">{{ fullName(onboardListEntry.crew_reliever) }}</a>
                </div>
                <div class="d-flex">
                  <div class="mr-1"
                       style="font-size: 16px; font-weight: bolder"
                       title="Tagged for Planned Promotion"
                  >
                    <b-icon-arrow-up
                        v-if="onboardListEntry.is_for_promotion"
                        class="text-success"
                    ></b-icon-arrow-up>
                  </div>

                    <button
                        v-if="onboardListEntry.active && isEditable"
                        class="btn btn-outline-primary btn-xs mr-2 px-2"
                        @click="setOnboardListIndex(index)"
                        :disabled="!isEditable"
                        data-target="#searchCrew"
                        data-toggle="modal"
                    >
                      <i class="fas fa-user-edit"></i>
                    </button>
                    <button
                        v-if="onboardListEntry.active && isEditable"
                        class="btn btn-outline-danger btn-xs px-2"
                        @click="deleteCrew(onboardListEntry)"
                        :disabled="!isEditable"
                    >
                      <i class="fas fa-trash"></i>
                    </button>
                </div>
              </div>

            </td>
          </template>
            <td
                :class="(onboardListEntry.experience_on_present_rank === null && onboardListEntry.crew_reliever !== '' ? 'empty_cell' : '') + ' ' +
                        (onboardListEntry.active === 1 || onboardListEntry.active === null ? '' : 'inactive-record')">
              <div v-if="onboardListEntry.experience_on_present_rank !== null" class="d-flex justify-content-around">
                <div class="text-center">
                  {{ onboardListEntry.experience_on_present_rank.year }}
                </div>
                <div class="text-center">
                  {{ onboardListEntry.experience_on_present_rank.month }}
                </div>
              </div>
            </td>
            <td
                :class="(onboardListEntry.experience_on_present_rank === null && onboardListEntry.crew_reliever !== '' ? 'empty_cell' : '') + ' ' +
                        (onboardListEntry.active === 1 || onboardListEntry.active === null ? '' : 'inactive-record')">
              <div v-if="onboardListEntry.experience_on_last_rank !== null" class="row">
                <div class="col-6 text-center">
                  {{ onboardListEntry.experience_on_last_rank.year }}
                </div>
                <div class="col-6 text-center">
                  {{ onboardListEntry.experience_on_last_rank.month }}
                </div>
              </div>
            </td>
          <td :class="onboardListEntry.active === 1 || onboardListEntry.active === null ? '' : 'inactive-record'">
            {{ onboardListEntry.last_vessel }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>

  <o-b-list-modal
    :oblist="sortedOnboardList"
    :oblist-index="onboardListIndex"
    :manning="params.manning_id"
    :default_rank="selectedRank"
    @return-crew="getCrew"
    @return-additional-crew="addAdditionalReliever">

  </o-b-list-modal>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import AppLoading from "@/components/elements/AppLoading.vue";
import { DateService } from "@/services/Utilities/DateService";
import {vueAppMixin} from "@/mixins/vueAppMixin";
import {dataMixin} from "@/mixins/dataMixin";
import {CrewService} from "@/services/CrewService";
import OBListModal
  from "@/components/sub_components/crew_change/ob_listing_with_earmarked_relievers/ob_llst_components/OBListModal.vue";
import {CrewActivityService} from "@/services/CrewActivityService";
import {BIconArrowUp, BIconArrowDown} from "bootstrap-vue";
import CrewActivity
  from "@/components/sub_components/master_lists/crews/crew_show_components/crew_activities/CrewActivity.vue";
import {gateMixin} from "../../../../mixins/gateMixin";

export default {
  name: "OBListingWithEarmarkedRelievers",
  components: {OBListModal, AppLoading, BIconArrowUp, BIconArrowDown},
  mixins: [vueAppMixin, dataMixin,gateMixin],
  data() {
    return {
      inOnboardListWithEarmarkedRelievers: [],
      isEditable: false,
      sortBy: {
        key: '',
        direction: ''
      },
      params: {
        manning_id: null,
        vessel_id: null
      },
      onboardListIndex: -1,
    }
  },

  computed: {
    CrewActivity() {
      return CrewActivity
    },
    ...mapGetters([
        "user",
        "manningKeys",
        "vesselKeys",
        "portKeys",
        "onboardWithEarmarkedRelievers"
    ]),

    selectedOnboardCrew() {
      if (this.onboardListIndex === -1) {
        return {
          disembarking_crew_activity: "",
          disembarking_crew_promotion_date: '',
          disembarking_crew_contract_duration: '',
          disembarking_crew_time_onboard: '',
          date_of_change: '',
          port_of_change: '',
          crew_reliever: {},
          crew_reliever_rank: {},
          experience_on_present_rank: {},
          experience_on_last_rank: {},
          active: false,
          last_vessel: ''
        }
      }

      return this.sortedOnboardList[this.onboardListIndex];
    },

    selectedOnboardList() {
      return this.inOnboardListWithEarmarkedRelievers.length === 0 ? this.onboardWithEarmarkedRelievers :
          this.inOnboardListWithEarmarkedRelievers;
    },

    sortedOnboardList() {
      if (this.sortBy.key === '') {
        return this.sortOBByDisembarkingCrewRank("asc", this.selectedOnboardList);
      }

      if (this.sortBy.key === "disembarking_crew_rank") {
        return this.sortOBByDisembarkingCrewRank(this.sortBy.direction, this.selectedOnboardList);
      } else if (this.sortBy.key === "disembarking_crew_name") {
        return this.sortOBByDisembarkingCrewName(this.sortBy.direction, this.selectedOnboardList);
      } else if (this.sortBy.key === 'disembarking_crew_embark_date') {
        return this.sortOBByEmbarkDate(this.sortBy.direction, this.selectedOnboardList);
      } else if (this.sortBy.key === "disembarking_crew_contract") {
        return this.sortOBByContractDuration(this.sortBy.direction, this.selectedOnboardList);
      } else if (this.sortBy.key === "disembarking_time_onboard") {
        return this.sortOBByTimeOnBoard(this.sortBy.direction, this.selectedOnboardList);
      }

      return this.sortOBByDisembarkingCrewRank("asc", this.selectedOnboardList);
    },

    selectedRank() {
      if (this.inOnboardListWithEarmarkedRelievers.length === 0) {
        return 0;
      }

      return this.selectedOnboardCrew.disembarking_crew_activity !== '' ?
          this.selectedOnboardCrew.disembarking_crew_activity.rank_id : 0
    },
    getManningLists(){
      return this.manningKeys.filter((manning)=>{
        return this.isKline ? ![7,17].includes(manning.id) : true
      })
    }
  },

  methods: {
    ...mapActions([
        "getManningKeys",
        "getVesselKeys",
        "getPortKeys",
        "getCrewList",
        "getOnboardListWithEarmarkedRelievers",
        "saveOnboardListWithEarmarkedRelievers",
    ]),

    ...mapMutations([
        "setOnboardWithEarmarkedRelievers",
        "SET_IS_LOADING",
        "setCrews",
        "setObListModalVisibility"
    ]),

    sortOBByTimeOnBoard(sort, sortedOnboardList){
      return sortedOnboardList.sort((onboardA, onboardB) => {
        if (onboardA.disembarking_crew_activity === '' || onboardB.disembarking_crew_activity === '') {
          return 1;
        }

        let timeOnboardA = [
          onboardA.disembarking_crew_time_onboard_value.year,
          onboardA.disembarking_crew_time_onboard_value.month,
          onboardA.disembarking_crew_time_onboard_value.days
        ].join("")

        let timeOnboardB = [
          onboardB.disembarking_crew_time_onboard_value.year,
          onboardB.disembarking_crew_time_onboard_value.month,
          onboardB.disembarking_crew_time_onboard_value.days
        ].join("");

        timeOnboardA = Number.parseInt(timeOnboardA);
        timeOnboardB = Number.parseInt(timeOnboardB);

        return sort === 'asc' ?
            timeOnboardA - timeOnboardB
            :
            timeOnboardB - timeOnboardA;
      })
    },

    sortOBByEmbarkDate(sort, sortedOnboardList) {
      return sortedOnboardList.sort((onboardA, onboardB) => {
        if (onboardA.disembarking_crew_activity === '' || onboardB.disembarking_crew_activity === '') {
          return 1;
        }

        let dateA = new Date(onboardA.disembarking_crew_activity.start_date);
        let dateB = new Date(onboardB.disembarking_crew_activity.start_date);

        return sort === "asc" ?
            dateA.getTime() - dateB.getTime()
            :
            dateB.getTime() - dateA.getTime();
      });
    },

    sortOBByDisembarkingCrewRank(sort, sortedOnboardList) {
      return sortedOnboardList.sort((onboardA, onboardB) => {
        if (onboardA.disembarking_crew_activity === '' || onboardB.disembarking_crew_activity === '') {
          return 1;
        }

        return sort === "asc" ?
            onboardA.disembarking_crew_activity.rank.ranking - onboardB.disembarking_crew_activity.rank.ranking
            :
            onboardB.disembarking_crew_activity.rank.ranking - onboardA.disembarking_crew_activity.rank.ranking;
      })
    },

    sortOBByDisembarkingCrewName(sort, sortedOnboardList) {
      return sortedOnboardList.sort((onboardA, onboardB) =>{
        if (onboardA.disembarking_crew_activity === '' || onboardB.disembarking_crew_activity === '') {
          return 1;
        }
            return sort === "asc" ?
                this.fullName(onboardA.disembarking_crew_activity.crew).localeCompare(this.fullName(onboardB.disembarking_crew_activity.crew))
                :
                this.fullName(onboardB.disembarking_crew_activity.crew).localeCompare(this.fullName(onboardA.disembarking_crew_activity.crew))
      });
    },

    sortOBByContractDuration(sort, sortedOnboardList) {
      return sortedOnboardList.sort((onboardA, onboardB) => {
        if (onboardA.disembarking_crew_activity === '' || onboardB.disembarking_crew_activity === '') {
          return 1;
        }

        return sort === "asc" ?
            onboardA.disembarking_crew_contract_duration - onboardB.disembarking_crew_contract_duration
            :
            onboardB.disembarking_crew_contract_duration - onboardA.disembarking_crew_contract_duration;
      });
    },

    sortColumn(key) {
      if (this.selectedOnboardList.length === 0){
        return;
      }

      if (this.sortBy.key !== key) {
        this.sortBy.key = key;
        this.sortBy.direction = "asc";
        return;
      }

      if (this.sortBy.direction === "asc") {
        this.sortBy.direction = "desc";
        return;
      }

      this.sortBy.key = "";
      this.sortBy.direction = "";
    },

    setOnboardListIndex(index) {
      this.onboardListIndex = index;
      this.setObListModalVisibility(true);
    },

    getDateToday() {
      return DateService.dateToday();
    },

    getCrewEmbarkationDate(onboardListEntry) {
      if (onboardListEntry.promotion_date) {
        return DateService.dateEliteFormat(onboardListEntry.promotion_date)
      }

      if (onboardListEntry.disembarking_crew_activity) {
        return DateService.dateEliteFormat(onboardListEntry.disembarking_crew_activity.start_date);
      }

      return '';
    },

    updateVesselKeys(){
      if (this.isOchg || !this.isSystemAdmin || this.isKobe) {
        this.params.vessel_id=null;
        let vesselParams = {
          manningId: this.params.manning_id
        };
        this.getVesselKeys(vesselParams);
      }
    },

    async getCrew(crew_id, is_for_promotion) {
      const crew_data = await CrewService.getCrewInfo({
        crewId: crew_id
      });

      const totalSeaExperience = await CrewActivityService.getTotalSeaExperience({
        crewId: crew_id,
        rankId: crew_data.rank_id
      });

      this.selectedOnboardCrew.crew_reliever = crew_data;

      if (is_for_promotion) {
        this.selectedOnboardCrew.experience_on_last_rank = totalSeaExperience;
      } else {
        this.selectedOnboardCrew.experience_on_present_rank = totalSeaExperience;
      }

      this.selectedOnboardCrew.crew_reliever_rank = crew_data.rank;
      const vessel = this.vesselKeys.find((vesselKey) => vesselKey.id === this.params.vessel_id)

      if (crew_data.currentActivity !== null && crew_data.currentActivity.activityCodeId === 2 &&
          crew_data.currentActivity.vesselName === vessel.name)
      {
        this.selectedOnboardCrew.last_vessel = "Currently Onboard for Overlapping";
      }else if (crew_data.currentActivity !== null && crew_data.currentActivity.activityCodeId === 2) {
        this.selectedOnboardCrew.last_vessel = "Currently Onboard " + crew_data.currentActivity.vesselName;
      }else if (crew_data.lastVessel !== null && crew_data.lastVessel.activityCodeId === 2) {
        this.selectedOnboardCrew.last_vessel = crew_data.lastVessel.vesselName;
      }

      this.selectedOnboardCrew.is_for_promotion = is_for_promotion;
      this.selectedOnboardCrew.active = 1;
    },

    async toggleEditButton() {
      if (!this.isEditable) {
        this.isEditable = true;
        this.inOnboardListWithEarmarkedRelievers = JSON.parse(JSON.stringify(this.onboardWithEarmarkedRelievers));
      } else {
        if (JSON.stringify(this.onboardWithEarmarkedRelievers) !==
            JSON.stringify(this.inOnboardListWithEarmarkedRelievers)) {
          if (!await this.confirmWarningAlert("Are you sure you want to cancel your changes?", "CANCEL CHANGES", "Yes", "No")) {
            return;
          }
        }
        this.isEditable = false;
        this.inOnboardListWithEarmarkedRelievers = [];
      }
    },

    async saveList() {
      if (!await this.confirmUpdate("Are you sure you want to save this list?")) {
        return;
      }

      if (JSON.stringify(this.onboardWithEarmarkedRelievers) ===
          JSON.stringify(this.inOnboardListWithEarmarkedRelievers)) {
        this.infoAlert("There are no changes to be saved!", "NO CHANGES");
        return;
      }

      if (this.validateList()) {
        return;
      }

      this.loadingWithMessage("Saving...");

      let result = await this.saveOnboardListWithEarmarkedRelievers({
        vessel_id: this.params.vessel_id,
        manning_id: this.params.manning_id,
        data: this.inOnboardListWithEarmarkedRelievers
      });

      if (!result) {
        this.errorAlert("Failed to save the updated list!", "SAVE")
        return;
      }

      this.successAlert("Successfully Saved Onboard list with Earmarked Relievers!", "SAVE");

      await this.getOnboardListWithEarmarkedRelievers(this.params);

      this.isEditable = false;
    },

    validateList() {
      let status = 0;

      for(let onboardEntryList of this.inOnboardListWithEarmarkedRelievers) {

        if (onboardEntryList.crew_reliever !== '' && onboardEntryList.date_of_change !== '') {
          if (new Date(onboardEntryList.date_of_change).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0) ||
              new Date(onboardEntryList.date_of_change).getFullYear() > 5000) {
            this.infoAlert("Invalid year has been set", "INVALID SAVE");
            status = 1;
            break;
          }
        }

        if (onboardEntryList.crew_reliever !== '' && (onboardEntryList.date_of_change === '' ||
          onboardEntryList.port_of_change === '')) {
          this.infoAlert("Please make sure you have filled up the list correctly!", "INVALID SAVE");
          status = 1;
          break;
        }
      }

      return status;
    },

    async deleteCrew(crewOnboard) {
     let crew = this.inOnboardListWithEarmarkedRelievers.find(onboardEntry => onboardEntry === crewOnboard);

      if (crew.earmarked_reliever_id !== undefined && crew.disembarking_crew_activity !== '') {
        if (!await this.confirmDeleteAlert("Are you sure you want to cancel this crew reliever record?")) {
          return;
        }
      } else if (crew.disembarking_crew_activity === "" && crew.earmarked_reliever_id !== undefined) {
        if (!await this.confirmDeleteAlert("Are you sure you want to cancel this crew reliever record?")) {
          return;
        }
        crew.hide_record = true;
      }

      crew.crew_reliever = "";
      crew.crew_reliever_rank = "";
      crew.date_of_change = "";
      crew.port_of_change = "";
      crew.experience_on_last_rank = "";
      crew.experience_on_present_rank = "";
      crew.last_vessel = "";
      crew.active = null;

      if (crew.disembarking_crew_activity === "" && crew.earmarked_reliever_id === undefined) {
        let index = this.inOnboardListWithEarmarkedRelievers.findIndex(onboardEntry => onboardEntry === crewOnboard);
        this.inOnboardListWithEarmarkedRelievers.splice(index, 1);
      }
    },

    async addAdditionalReliever(crew_id, is_for_promotion) {
      const newEarmarkedRelieverEntry = this.selectedOnboardCrew;

      const crew_data = await CrewService.getCrewInfo({
        crewId: crew_id
      });

      const totalSeaExperience = await CrewActivityService.getTotalSeaExperience({
        crewId: crew_id,
        rankId: crew_data.rank_id
      });

      if (crew_data.currentActivity !== null && crew_data.currentActivity.activityCodeId === 2) {
        newEarmarkedRelieverEntry.last_vessel = "Currently Onboard " +  crew_data.currentActivity.vesselName;
      } else if (crew_data.lastVessel !== null && crew_data.lastVessel.activityCodeId === 2) {
        newEarmarkedRelieverEntry.last_vessel = crew_data.lastVessel.vesselName;
      }

      newEarmarkedRelieverEntry.crew_reliever = crew_data;

      if (is_for_promotion) {
        newEarmarkedRelieverEntry.experience_on_last_rank = totalSeaExperience;
      } else {
        newEarmarkedRelieverEntry.experience_on_present_rank = totalSeaExperience;
      }
      newEarmarkedRelieverEntry.crew_reliever_rank = crew_data.rank;

      newEarmarkedRelieverEntry.is_for_promotion = is_for_promotion;
      newEarmarkedRelieverEntry.active = 1;

      this.inOnboardListWithEarmarkedRelievers.push(newEarmarkedRelieverEntry);
    },
  },

  created() {
    this.params.manning_id = this.user.manning_id;
    this.SET_IS_LOADING(false);
    this.getManningKeys();
    if (this.user.manning_id) this.updateVesselKeys();
    this.getPortKeys();
  },

  watch: {
    'params.manning_id'() {
      this.updateVesselKeys();
      document.querySelector("#manningNullOption").style.display = "none";
    },

    "params.vessel_id"() {
      if (this.params.vessel_id === null){
        document.querySelector("#vesselNullOption").style.display = "block";
        this.setOnboardWithEarmarkedRelievers([]);
        this.isEditable = false;
        this.inOnboardListWithEarmarkedRelievers = [];
        return;
      }

      this.isEditable = false;
      this.inOnboardListWithEarmarkedRelievers = [];
      this.getOnboardListWithEarmarkedRelievers(this.params);
      document.querySelector("#vesselNullOption").style.display = "none";
    },
  },

  destroyed() {
    this.setOnboardWithEarmarkedRelievers([]);
    this.setCrews([]);
  }
}
</script>

<style scoped>
  .empty_cell {
    background-color: gray;
    opacity: 0.5;
  }

  .required_field {
    border-color: red;
  }

  .hide_record {
    display: none;
  }

  .divider {
    border-right: 2px solid #666666
  }

  .inactive-record {
    background-color: #666666;
    opacity: 0.5;
    color: white;
  }
</style>